<div class="voice-navigation-container" *ngIf="isSupported">
  <!-- Floating Voice Button -->
  <div class="voice-button-container">
    <button 
      (click)="toggleListening()"
      [class.listening]="isListening"
      class="voice-button"
      [attr.aria-label]="isListening ? 'Stop voice recognition' : 'Start voice recognition'"
      title="{{ isListening ? 'Stop listening' : 'Start voice navigation' }}">
      
      <!-- Microphone Icon -->
      <svg *ngIf="!isListening" class="voice-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
              d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z">
        </path>
      </svg>
      
      <!-- Stop Icon -->
      <svg *ngIf="isListening" class="voice-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
              d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z">
        </path>
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
              d="M9 10a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z">
        </path>
      </svg>
    </button>

    <!-- Help Button -->
    <button 
      (click)="toggleHelp()"
      class="help-button"
      title="Voice commands help">
      <svg class="help-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
              d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z">
        </path>
      </svg>
    </button>
  </div>

  <!-- Voice Status Indicator -->
  <div *ngIf="isListening" class="voice-status">
    <div class="voice-pulse"></div>
    <span class="voice-status-text">Listening...</span>
  </div>

  <!-- Last Command Display -->
  <div *ngIf="lastCommand" class="last-command">
    <span class="command-text">"{{ lastCommand }}"</span>
  </div>

  <!-- Help Panel -->
  <div *ngIf="showHelp" class="help-panel">
    <div class="help-header">
      <h3>Voice Commands</h3>
      <button (click)="toggleHelp()" class="close-help">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>
    <div class="help-content">
      <p class="help-intro">Say these commands to navigate:</p>
      <div class="commands-list">
        <div *ngFor="let command of availableCommands" class="command-item">
          <span class="command-phrase">"{{ command.command }}"</span>
          <span class="command-description">{{ command.description }}</span>
        </div>
      </div>
      <div class="help-tips">
        <p><strong>Tips:</strong></p>
        <ul>
          <li>Speak clearly and at a normal pace</li>
          <li>Say "stop listening" to turn off voice recognition</li>
          <li>Say "help" anytime to see this list</li>
        </ul>
      </div>
    </div>
  </div>
</div>

<!-- Fallback for unsupported browsers -->
<div *ngIf="!isSupported" class="voice-unsupported">
  <div class="unsupported-message">
    <svg class="unsupported-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z">
      </path>
    </svg>
    <span>Voice navigation is not supported in this browser</span>
  </div>
</div> 